import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinhavelipune() {



  const cardData =
  {
    keyword: 'Bus On Rent in Haveli Pune',
    heading: 'Sanavi Travels: Bus On Rent in Haveli Pune',
    headingDescription: 'Sanavi Travels offers reliable Bus On Rent in Haveli Pune, providing safe, comfortable, and spacious transportation for families, groups, corporate trips, school excursions, weddings, and pilgrimage travel. Our fleet of well-maintained AC and non-AC buses, mini buses, and luxury coaches ensures ample seating, smooth rides, and sufficient luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Haveli Taluka, Pune, and nearby areas, making it ideal for local travel, outstation trips, corporate events, and group tours. Choose Sanavi Travels for trusted bus rental services in Haveli Pune, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical monument and a proud symbol of Maratha valor. Once the administrative center of the Maratha Empire, the fort features massive stone walls, grand gateways like the Delhi Darwaza, and sprawling courtyards. The evening light-and-sound show narrates the glorious history of the Peshwas, making it a must-visit heritage attraction."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a nationally significant monument closely associated with India’s freedom movement. Mahatma Gandhi and Kasturba Gandhi were imprisoned here during the Quit India Movement. Today, it houses a museum with personal belongings, photographs, and memorials, set amidst beautifully landscaped gardens that offer peace and reflection."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark. The richly adorned idol of Lord Ganesha attracts thousands of devotees daily, especially during Ganesh Chaturthi when grand celebrations take place. The temple trust is also known for its charitable and social initiatives."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fort famous for the bravery of Tanaji Malusare and the legendary battle fought for Chhatrapati Shivaji Maharaj. The fort offers panoramic views of the Sahyadri ranges and Pune city. Trekking enthusiasts and history lovers visit it for its scenic beauty and historical significance."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. Despite being located in the heart of the city, it offers a calm and spiritual atmosphere, showcasing ancient Indian architectural excellence."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts representing India’s cultural and artistic heritage. From traditional musical instruments to household antiques and sculptures, the museum provides deep insight into India’s rich craftsmanship and history."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering breathtaking views of the city after climbing 103 stone steps. The hilltop temple complex, built during the Peshwa era, is dedicated to Lord Shiva and Goddess Parvati and is especially popular during sunrise and sunset."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort attracts visitors from across the world. Known for meditation programs, wellness therapies, and peaceful gardens, it serves as a global center for mindfulness, relaxation, and spiritual growth."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With flowing water streams, wooden bridges, and lush greenery, it offers a serene escape for families, walkers, and photography enthusiasts."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular leisure destination on the outskirts of Pune. Especially scenic during the monsoon season, it offers beautiful views of the reservoir and surrounding hills. The area is also a gateway to Sinhagad Fort and a favorite spot for evening outings."
  }
]
,



"services": [
{
"name": "Bus On Rent in Haveli Pune",
"description": "Bus On Rent in Haveli Pune provides dependable and comfortable bus rental services for all types of travel needs. Whether for family outings, religious trips, corporate travel, or social events, these buses are well-maintained, spacious, and driven by experienced professionals to ensure a safe, smooth, and enjoyable journey across local and outstation routes."
},
{
"name": "Bus Hire Haveli Pune",
"description": "Bus Hire Haveli Pune offers flexible and convenient bus hiring solutions for individuals, groups, and organizations. With multiple seating capacities, modern interiors, and transparent pricing, this service is ideal for weddings, corporate tours, school trips, and long-distance travel from Haveli Pune."
},
{
"name": "AC Bus Haveli Pune",
"description": "AC Bus Haveli Pune ensures a comfortable and refreshing travel experience with fully air-conditioned buses. Designed for long journeys and group travel, these buses provide relaxed seating, clean interiors, and smooth rides, making them perfect for tourists, corporate teams, and family travelers."
},
{
"name": "Luxury Bus Haveli Pune",
"description": "Luxury Bus Haveli Pune offers premium travel solutions with high-end buses featuring pushback seats, ample legroom, and superior comfort. Ideal for weddings, VIP travel, corporate events, and luxury tours, these buses elevate the overall travel experience with style and convenience."
},
{
"name": "Wedding Bus Haveli Pune",
"description": "Wedding Bus Haveli Pune specializes in transportation for wedding guests and family members. Spacious seating, punctual service, and professional drivers ensure guests travel together comfortably and arrive on time for wedding ceremonies and celebrations."
},
{
"name": "Corporate Bus Haveli Pune",
"description": "Corporate Bus Haveli Pune provides efficient and professional transport solutions for office staff, meetings, conferences, and corporate outings. With disciplined drivers, comfortable buses, and timely pickups, it ensures smooth and stress-free corporate travel."
},
{
"name": "Outstation Bus Haveli Pune",
"description": "Outstation Bus Haveli Pune offers reliable bus services for long-distance travel to nearby cities and tourist destinations. Well-maintained buses, experienced drivers, and flexible travel plans make it suitable for family trips, group tours, and corporate travel."
},
{
"name": "Affordable Bus Haveli Pune",
"description": "Affordable Bus Haveli Pune delivers budget-friendly bus rental options without compromising on safety or comfort. Ideal for schools, families, social groups, and religious tours, it combines economical pricing with dependable service."
},
{
"name": "Chauffeur Driven Bus Haveli",
"description": "Chauffeur Driven Bus Haveli ensures a hassle-free travel experience with trained and professional drivers managing routes, traffic, and schedules. Passengers can relax and enjoy the journey, making it perfect for events, tours, and group travel."
},
{
"name": "Best Bus Service Haveli Pune",
"description": "Best Bus Service Haveli Pune is known for its punctuality, clean buses, and customer-focused approach. Suitable for weddings, corporate travel, tourism, and group outings, it guarantees a reliable and comfortable journey every time."
},
{
"name": "Tourist Bus Haveli Pune",
"description": "Tourist Bus Haveli Pune caters to travelers exploring Pune and nearby tourist destinations. With flexible itineraries, spacious seating, and knowledgeable drivers, it offers a convenient and enjoyable sightseeing and travel experience."
},
{
"name": "Group Travel Bus Haveli",
"description": "Group Travel Bus Haveli provides organized transportation for large groups such as friends, families, corporate teams, and tour groups. Comfortable buses and coordinated travel arrangements ensure everyone travels together safely and conveniently."
},
{
"name": "Online Bus Booking Haveli Pune",
"description": "Online Bus Booking Haveli Pune allows quick and easy bus reservations with instant confirmation. Travelers can choose from multiple bus options, plan schedules efficiently, and enjoy a seamless booking experience from the comfort of their home."
},
{
"name": "Event Bus Haveli Pune",
"description": "Event Bus Haveli Pune offers dedicated transportation services for concerts, conferences, parties, exhibitions, and special events. Reliable scheduling, comfortable buses, and professional drivers ensure smooth movement of guests and participants."
},
{
"name": "Haveli Travel Bus",
"description": "Haveli Travel Bus provides comprehensive travel solutions for local and outstation journeys. Combining comfort, safety, affordability, and professional service, it caters to tourists, families, corporate clients, and group travelers."
}
],
"tableData": [
["Bus On Rent in Haveli Pune", "Bus Hire Haveli Pune"],
["AC Bus Haveli Pune", "Luxury Bus Haveli Pune"],
["Wedding Bus Haveli Pune", "Corporate Bus Haveli Pune"],
["Outstation Bus Haveli Pune", "Affordable Bus Haveli Pune"],
["Chauffeur Driven Bus Haveli", "Best Bus Service Haveli Pune"],
["Tourist Bus Haveli Pune", "Group Travel Bus Haveli"],
["Online Bus Booking Haveli Pune", "Event Bus Haveli Pune"],
["Haveli Travel Bus", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Haveli Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and affordable bus rental services in Haveli Pune, perfect for group travels, school trips, corporate outings, and pilgrimages."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and routinely serviced to ensure a smooth and comfortable journey for all passengers."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are well-versed with the routes around Haveli Pune, ensuring safe, timely, and pleasant travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for bus rentals in Haveli Pune, including fuel, tolls, and driver allowances with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to help with bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized rental packages based on your group’s schedule and travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rentals in Haveli Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Haveli Pune?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Haveli Pune for various travel needs.'
  },
  {
    question: 'How can I book a bus in Haveli Pune?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Haveli Pune?',
    answer: 'Sanavi Travels offers a variety of buses including mini buses, 20-seater, 32-seater, 45-seater, and 50-seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Haveli Pune?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Haveli Pune region, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations in Haveli Pune?',
    answer: 'Absolutely. You can select your preferred pickup and drop-off locations within Haveli Pune.'
  },
  {
    question: 'Is the bus service in Haveli Pune available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock bus rental services in Haveli Pune to suit your schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Haveli Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Shinde',
    feedback: 'We rented a bus in Haveli Pune from Sanavi Travels and had a comfortable and smooth trip. Excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Sanavi Travels provided a great bus service with a professional driver and on-time pickups. Highly recommended!',
    rating: 5
  }
];







































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Haveli Pune - Sanavi Travels",
  "description": "Sanavi Travels offers AC, luxury, and chauffeur-driven buses on rent in Haveli Pune for weddings, corporate events, family trips, and group travel. Affordable and reliable bus hire with online booking available.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "45"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Bus On Rent in Haveli Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels offers AC, luxury, and chauffeur-driven buses on rent in Haveli Pune for weddings, corporate events, family trips, and group travel. Affordable and reliable bus hire with online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/126.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinhavelipune;